module.exports = __webpack_public_path__ + "img/LUB00344.3edf9787.svg";